import React from 'react'
import { Gem } from 'lucide-react'
import { assetSrc } from '../lib/assets'

interface ProductImageProps {
  src?: string | null | undefined
  alt: string
  className?: string
  imgClassName?: string
}

export const ProductImage: React.FC<ProductImageProps> = ({
  src,
  alt,
  className = '',
  imgClassName = '',
}) => {
  const [error, setError] = React.useState(false)
  const resolved = assetSrc(src)

  React.useEffect(() => {
    setError(false)
  }, [resolved])

  if (!resolved || error) {
    return (
      <div
        className={`flex items-center justify-center bg-gradient-to-br from-[var(--bg-surface-2)] to-[var(--bg-surface-3)] border border-[var(--border)] ${className}`}
        role="img"
        aria-label={alt}
      >
        <Gem className="w-10 h-10 text-[var(--gold-main)]/40" />
      </div>
    )
  }

  return (
    <img
      src={resolved}
      alt={alt}
      onError={() => setError(true)}
      className={imgClassName}
    />
  )
}
